import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React, { Fragment, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { MainTariff } from './MainTariff';
import { useEditContext } from 'ra-core';
import Color from '../../layout/color/Color';
import FontSize from '../../layout/FontSize';



const viewButton = {
  bgcolor: Color.Main,
  borderRadius: '30px',
  border: "1px solid #ccc",
  color: Color.Button,
  fontWeight: '500',
  textAlign: 'center',
  padding: '8px 15px',
  transition: '0.3s',
  fontSize: FontSize.Medium,
  textTransform: 'none',
  '&:hover': { background: Color.Button, color: Color.Normal }
};
const TerminalTariffButton = () => {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const { record, isLoading } = useEditContext();

  return (
    <Fragment>
      <Button
       size="large" 
       onClick={handleOpen}
       sx={viewButton}
       >
        View Tariff
      </Button>
      <Dialog onClose={handleClose} open={open} maxWidth="lg">
        <DialogTitle sx={{ m: 0, p: 2, fontWeight: '600' }}>
          Detail Tariff
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {isLoading ? 'Loading...' : <MainTariff record={record} />}
        </DialogContent>
      </Dialog>
    </Fragment>
  );
};

export default TerminalTariffButton;
